<template>
  <div class="employeeRoster page-customer">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">项目名称</div>
            <el-input size="small" v-model="infoQuery.objname" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">导入状态</div>
            <el-select v-model="infoQuery.stremptype" filterable @change="searchHandle" clearable>
              <el-option label="全部" value="0"></el-option>
              <el-option label="已导入" value="1"></el-option>
              <el-option label="未导入" value="2"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">项目状态</div>
            <el-select v-model="infoQuery.strbusistat" filterable @change="searchHandle" clearable>
              <el-option value="合作中"></el-option>
              <el-option value="已暂停"></el-option>
              <el-option value="已终止"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="text" @click="dropDownScreen" style="margin-right:10px;">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
        <button class="exportButton" @click="exportAllInfo">
          全员导出
        </button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="cus_down_box">
          <el-form :inline="true" :model="infoQuery" class="cus_down_form" label-width="100px">
            <el-form-item label="服务中心:">
              <el-select v-model="infoQuery.strsrvcent" filterable @change="serviceChange" clearable>
                <el-option v-for="(item, index) in serviceList" :key="index" :label="item.StrSrvCent" :value="item.StrSrvCent"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务立项部门:">
              <el-select v-model="infoQuery.strobjinstname" filterable clearable>
                <el-option v-for="(item, index) in apartmentList" :key="index" :label="item.StrObjInstName" :value="item.StrObjInstName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="负责客服:">
              <el-input size="small" v-model="infoQuery.strusername" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="resetHandle()">
            清空
          </button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/signupList' }">面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item>项目列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="employeeRosterTable">
        <ResourceComTabs ref="child" :active="activeName" :btnAuth="permissionLists" @change="currChange($event)"></ResourceComTabs>
        <el-table :data="tableData" :max-height="tableHeight - 180" :cell-style="columnStyle" v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="40px"></el-table-column> -->
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{ $index }">
              <span>{{
                (Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) +
                Number($index) + 1
                }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" prop="StrObjName" min-width="140px" fit show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color: #19bd92" @click="handdle(scope.row)">{{ scope.row.StrObjName ? scope.row.StrObjName : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="服务中心" prop="StrSrvCent" min-width="120px" fit show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.StrSrvCent ? scope.row.StrSrvCent : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="业务立项部门" prop="StrObjInstName" min-width="130px" fit show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                scope.row.StrObjInstName ? scope.row.StrObjInstName : "-"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目类别" prop="StrProjectType" fit show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.StrProjectType ? scope.row.StrProjectType : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="负责客服" prop="StrUserName" fit show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                scope.row.StrUserName ? scope.row.StrUserName : "-"
                }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目状态" prop="StrBusiStat">
          </el-table-column>
          <el-table-column align="center" label="省" prop="StrProProvince">
          </el-table-column>
          <el-table-column align="center" label="市" prop="StrProCity">
          </el-table-column>
          <el-table-column align="center" label="区" prop="strArea">
          </el-table-column>
          <el-table-column align="center" sortable label="在职人数" prop="IsWork">
            <template slot-scope="scope">
              <span>{{ scope.row.IsWork ? scope.row.IsWork : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" sortable label="离职人数" prop="NotWork">
            <template slot-scope="scope">
              <span>{{ scope.row.NotWork ? scope.row.NotWork : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" sortable label="黑名单数" prop="IsBlack">
            <template slot-scope="scope">
              <span>{{ scope.row.IsBlack ? scope.row.IsBlack : "-" }}</span>
            </template>
          </el-table-column>
         <el-table-column align="center" sortable label="未发薪数" prop="EmpNotSalary">
            <!-- <template slot-scope="scope">
              <span>{{ scope.row.EmpNotSalary }}</span>
            </template> -->
          </el-table-column>
          <el-table-column align="center" sortable label="雇员总数" prop="count">
            <template slot-scope="scope">
              <span>{{ scope.row.count ? scope.row.count : "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="80px">
            <template slot-scope="{row}">
              <el-tooltip effect="dark" content="该客户无导入数据不能导出" :disabled="!isNull(row.count)" placement="top">
                <div style="display: inline-block">
                  <el-button plain type="success" size="mini" @click="exportInfo(row)" :disabled="isNull(row.count)">导出</el-button>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="totalcount > 0">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" :current-page.sync="infoQuery.currpage" :page-sizes="[10, 20, 50, 100]" :page-size="infoQuery.pagecount" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog :visible.sync="visibleReading" width="700px" :show-close="false" :close-on-click-modal="false">
        <div class="diaTitle">导入说明</div>
        <div style="margin-top: 15px; padding-bottom: 15px">
          <div class="note-txt">
            <p class="tips redtips">● 线下花名册：各客服编辑的Excel文档。</p>
            <p class="tips redtips">
              ● 存档花名册：等于线下花名册导入数据，每月25号到次月2号导入。
            </p>
            <p class="tips redtips">
              ● 招聘管理-流程数据：等于线下花名册导入数据 + 招聘流程数据。
            </p>
            <p class="tips">● 运营报表数据：根据招聘流程数据生成。</p>
            <p class="tips">● 提示说明</p>
            <p style="padding-left: 25px; margin-top: 5px">
              1. 如员工信息变更时，需线下花名册和招聘流程数据同时变更。
            </p>
            <p style="padding-left: 25px; margin-top: 5px">
              2.
              如A员工身份证号一致，线下花名册导入后线下花名册会覆盖招聘流程数据；若A员工身份证号不一致，2号导入后两条数据在流程中分别显示。
            </p>
          </div>
        </div>
        <div style="
            display: flex;
            justify-content: flex-end;
            -webkit-justify-content: flex-end;
            padding-bottom: 30px;
          ">
          <el-button type="primary" size="small" :disabled="countdown > 0" @click="closeRead">继续 {{ countdown == 0 ? "" : "（" + countdown + "）" }}</el-button>
        </div>
      </el-dialog>
      <!-- 在离职状态选择 -->
      <el-dialog :visible.sync="expSelectDialog" width="480px">
        <div class="delTitle">选择导出人员在/离职状态</div>
        <div>
          <div class="dataSele">
            <el-select v-model="workState" slot="prepend" placeholder="请选择" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option value="在职"></el-option>
              <el-option value="离职"></el-option>
              <el-option value="离职转正"></el-option>
              <el-option value="自离"></el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="expSelectDialog = false">关闭</button>
          <button class="search" @click="sureExportHandle" style="margin-left: 10px; font-weight: 600">
            导出
          </button>
        </span>
      </el-dialog>
      <!-- 导出 -->
      <el-dialog :visible.sync="dialogVisible4" width="800px">
        <div class="diaTitle">全员导出</div>
        <div>
          <div style="margin-bottom: 12px; margin-top: 15px; font-size: 16px">
            选择导出字段
          </div>
          <el-tabs type="border-card">
            <el-tab-pane label="固定字段">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group v-model="checkedFields" @change="handleCheckedCitiesChange">
                <div class="fieldBox">
                  <el-checkbox v-for="(field, index) in fixedfields" :label="field" :key="index">{{ field }}</el-checkbox>
                </div>
              </el-checkbox-group>
            </el-tab-pane>
          </el-tabs>
          <div style="margin-top: 20px">
            <div class="delTitle">选择导出人员在/离职状态</div>
            <div>
              <div class="dataSele">
                <el-select v-model="workState" slot="prepend" placeholder="请选择" filterable>
                  <el-option label="全部" value=""></el-option>
                  <el-option value="在职"></el-option>
                  <el-option value="离职"></el-option>
                  <el-option value="离职转正"></el-option>
                  <el-option value="自离"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible4 = false">取消</button>
          <button class="search" @click="confirmExport()" style="margin-left: 10px; font-weight: 600">
            确定
          </button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    VueTreeList,
    Tree
  } from "vue-tree-xz";
  import ResourceComTabs from "./components/resourceComTabs.vue"
  import checkPermission from "@/utils/permission"; // 权限判断函数
  import xz from "../../common";
  export default {
    components: {
      ResourceComTabs
    },
    data() {
      return {
        activeName: "项目列表",
        //是否下载过导入模板
        isDownload: false,
        visibleReading: true,
        countdown: 30,
        rowinfo: null,
        //在/离职状态
        workState: "",
        //导出弹窗
        expSelectDialog: false,
        //角色类型
        roleType: "",
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight: 0,
        //所有导入字段
        currFileData: [],
        checkAll: false,
        checkedFields: [],
        fixedfields: [],
        otherfields: [],
        tableclumn: [],
        tableclumn1: [],
        tableclumn2: [],
        isIndeterminate: true,
        listLoading: false,
        totalcount: 0,
        showResult: false,
        //下拉筛选
        showDropScreen: -1,
        //导出
        dialogVisible4: false,
        tableData: [],
        //下拉服务中心列表
        serviceList: [],
        //下拉业务立项部门
        apartmentList: [],
        //项目列表参数
        infoQuery: {
          pagecount: 10,
          currpage: 1,
          objname: "", //项目名称
          ctluserid: "",
          strsrvcent: "", //服务中心
          strobjinstname: "", //立项部门
          strusername: "", //客服名称
          strbusistat: "", //服务状态
          stremptype: "0",
          roletype: ""
        },
        allFieldList: [],
        //导出按钮加载状态
        btnLoading: false,
        // 导出新花名册参数
        exportNewQuery: {},
        // 参数列表参数
        paramQuery: {
          currpage: 1,
          perpage: 100000,
          keyword: "",
          strIsDisable: "", // 传1 禁用的看不到了  不传就全显示
          // JB_base_Busitype 业务类型 JB_base_Custprolevel客户项目等级
          // JB_base_Jobfunclabel 岗位职能标签 JB_base_Socialsec社保 JB_base_Busisec 商保
          strtableid: "",
        },
        // 选中的服务部门
        dedpartNameList: [],
        // 选中的归属业务部门
        busDedpartList: [],
        positionList: [],
        // 部门参数
        departQuery: {
          strorgancode: "",
          roletype: "",
        },
        // 部门
        departList: [],
        // 员工参数
        departMemberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        },
        // 按钮权限参数
        butQuery: {
          path: '/signupList',
          powerEnName: 'employee'
        },
        permissionLists: [], //按钮权限列表
        // 自定义 级联选择props
        props: {
          label: "strorganname",
          value: "strorgancode",
          children: "children",
          checkStrictly: true,
        },
        propPosition: {
          label: "strParametername",
          value: "strParametername",
          children: "children",
        },
        monthFirstDates: ""
      };
    },
    created() {
      this.infoQuery.roletype = localStorage.loginRoletype;
      this.departQuery.roletype = localStorage.loginRoletype;
      this.departQuery.strorgancode = localStorage.gancode;
      if (window.localStorage.getItem("loginRoletype")) {
        this.roleType = window.localStorage.getItem("loginRoletype");
      }
      if (window.localStorage.getItem("isDownload")) {
        this.calDaysBetween(window.localStorage.getItem("isDownload"));
      }
      let dateMoments = new Date();
      this.monthFirstDates =
        dateMoments.getFullYear() +
        "-" +
        (dateMoments.getMonth() + 1) +
        "-" +
        dateMoments.getDate();
      if (
        window.localStorage.getItem("visibleReadingCustomer") !=
        this.monthFirstDates &&
        (this.checkPermission(['signupList_tab_roster'], this.permissionLists) && (localStorage.loginRoletype.indexOf('adm') == -1))
      ) {
        this.visibleReading = true;
        this.countdown = 30;
        this.timecount();
      } else {
        this.visibleReading = false;
      }
      this.getButtonPower();
      this.calHeight();
      this.getCustomerList(this.infoQuery);
      this.getServiceList();
      this.getApartmentList("", "");
      this.getImportFiledList();
      // 获取部门列表
      this.getDepartList();
    },
    computed: {
      searchResult() {
        if (this.$store.state.ADDCOMPANY.customerMatch.length > 0) {
          this.showResult = true;
        }
        return this.$store.state.ADDCOMPANY.customerMatch;
      },
    },
    methods: {
      checkPermission,
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        // console.log('height', this.tableHeight)
      },
      exportInfo(row) {
        this.rowinfo = row;
        this.expSelectDialog = true;
      },
      // 单个项目导出
      sureExportHandle() {
        let query = {
          strworkstate: this.workState,
          custname: this.rowinfo.StrObjName,
          outtype: "0",
          tableid: "JB_emp_UserBase",
          roletype: localStorage.loginRoletype,
          tableclumn: this.allFieldList
        };
        // console.log('导出', data)
        var Promise = xz.bdowncurrdata(query);
        this.$router.push({
          path: "/resImportList",
          query: {
            showPage: 1,
            isActive: 1,
            custname: this.rowinfo.StrObjName,
            //qStstus=1时查看最后一条导出记录
            qStstus: 1,
          },
        });
        this.dialogVisible4 = false;
      },
      // 子组件传值
      async currChange(value) {
        // console.log('currChange',value)
        this.activeName = value
        this.getCustomerList(this.infoQuery);
      },
      // 获取按钮权限
      getButtonPower() {
        let that = this;
        xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
          // console.log('按钮',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = [];
            }
          } else {
            this.permissionLists = [];
          }
        });
      },
      // 导出新花名册
      exportHandle() {
        this.btnLoading = true;
        this.exportNewQuery.custname = this.rosterQuery.custname;
        this.exportNewQuery.username = this.rosterQuery.username;
        this.exportNewQuery.depname = this.rosterQuery.depname;
        this.exportNewQuery.servicename = this.rosterQuery.servicename;
        this.exportNewQuery.strWork = this.rosterQuery.strWork;
        this.exportNewQuery.strtel = this.rosterQuery.strtel;
        this.exportNewQuery.strjobtype = this.rosterQuery.strjobtype;
        this.exportNewQuery.actualtype = this.rosterQuery.actualtype;
        this.exportNewQuery.strDep1 = this.rosterQuery.strDep1;
        this.exportNewQuery.strDep2 = this.rosterQuery.strDep2;
        this.exportNewQuery.strDep3 = this.rosterQuery.strDep3;
        this.exportNewQuery.strservuserid = this.rosterQuery.strservuserid;
        this.exportNewQuery.strAchievedep = this.rosterQuery.strAchievedep;
        this.exportNewQuery.strAchieveowner = this.rosterQuery.strAchieveowner;
        this.exportNewQuery.strRecchannel = this.rosterQuery.strRecchannel;
        this.exportNewQuery.strRecsult = this.rosterQuery.strRecsult;
        this.exportNewQuery.strRecdep = this.rosterQuery.strRecdep;
        this.exportNewQuery.strcity = this.rosterQuery.strcity;
        this.exportNewQuery.roletype = this.rosterQuery.roletype;
        this.exportNewQuery.strorgancode = this.rosterQuery.strorgancode;
        xz.getOutEmpBaseUser(this.exportNewQuery).then((res) => {
          // console.log('导出新花名册', res)
          if (res.status == "ok") {
            // console.log('导出', data)
            this.$router.push({
              path: "/operationRecord",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                //qStstus=1时查看最后一条导出记录
                qStstus: 1,
              },
            });
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error",
            });
          }
          this.btnLoading = false;
        });
      },
      //获取列表
      getCustomerList(query) {
        // console.log('info',this.infoQuery)
        this.listLoading = true;
        xz.bgetempcustlist(query,this.roleType,'ByProject').then((res) => {
          if (res) {
            let msgdata = res.msg.data;
            let countinf = res.msg.countinf;
            if (countinf && countinf.length > 0) {
              for (var i = 0; i < countinf.length; i++) {
                let item = JSON.parse(countinf[i])
                var NotWork =
                  Number(item.count) -
                  Number(item.IsWorkCount);
                var IsBlack = item.IsWhiteCount;
                msgdata[i]["NotWork"] = NotWork;
                msgdata[i]["IsBlack"] = IsBlack;
                msgdata[i]["count"] = parseInt(item.count);
                msgdata[i]["IsWork"] = parseInt(item.IsWorkCount);
                msgdata[i]["EmpNotSalary"] = item.EmpNotSalary;
                msgdata[i]["excelpath"] = item.excelpath;
              }
            }
            this.tableData = msgdata;
            this.showDropScreen = -1;
            this.totalcount = parseInt(res.msg.totalcount);
          } else {
            this.tableData = [];
            this.totalcount = 0;
            this.showDropScreen = -1;
          }
          this.listLoading = false;
        });
      },
      handleCurrentChange(val) {
        this.infoQuery.currpage = Number(`${val}`);
        this.getCustomerList(this.infoQuery);
      },
      handleSizeChange(val) {
        this.infoQuery.pagecount = Number(`${val}`);
        this.infoQuery.currpage = 1;
        this.getCustomerList(this.infoQuery);
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //下载模板
      downLoadHandle() {
        xz.getImportMode().then((res) => {
          // console.log('下载模板', res)
          if (res) {
            this.isDownload = true;
            window.localStorage.setItem("isDownload", new Date());
            var d = res.msg.data.StrOutPath;
            d = d.replace('"', "").replace('"', "");
            var path = this.tablePath + d;
            const aTag = document.createElement("a");
            aTag.href = path;
            aTag.click();
          }
        });
      },
      calDaysBetween(date) {
        let startDate = Date.parse(date);
        let endDate = Date.parse(new Date());
        let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        days > 7 ? (this.isDownload = false) : (this.isDownload = true);
      },
      serviceChange() {
        this.getApartmentList(this.infoQuery.strsrvcent, this.infoQuery.objname);
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
          strIsDisable: "",
        }).then((res) => {
          // console.log('部门', res)
          if (res.status == "ok") {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children;
            }
          } else {
            this.departList = [];
          }
        });
      },
      //下拉服务中心列表
      getServiceList() {
        xz.getsrarchinstlist().then((res) => {
          // console.log("getServeList", res);
          let dataList = [];
          for (let index = 0; index < res.length; index++) {
            const service = res[index];
            dataList.push({
              StrSrvCent: service.Strinstname
            });
          }
          // console.log("getServeList", dataList);
          this.serviceList = dataList;
        });
      },
      //下拉立项部门
      getApartmentList(strsrvcent, strobjname) {
        xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then((res) => {
          let dataList = [];
          for (let index = 0; index < res.length; index++) {
            const apartmentData = res[index];
            dataList.push({
              StrObjInstName: apartmentData.StrObjInstName
            });
          }
          // console.log("getServeList", dataList);
          this.apartmentList = dataList;
        });
      },
      //清空
      resetHandle() {
        this.infoQuery = this.$options.data.call(this).infoQuery
        this.infoQuery.roletype = localStorage.loginRoletype
        this.dedpartNameList = [];
        this.busDedpartList = [];
      },
      //搜索
      searchHandle() {
        this.infoQuery.currpage = 1;
        this.getCustomerList(this.infoQuery);
      },
      exportAllInfo() {
        this.getlastExportList();
      },
      //全员导出字段全选
      handleCheckAllChange(val) {
        // this.tableclumn = this.currFileData;
        this.checkedFields = val ? this.fixedfields : [];
        this.tableclumn1 = val ? this.currFileData : [];
        if (val == false) {
          this.tableclumn1 = [{
            colname: "StrIdCard",
            name: "身份证号码",
            intOrderId: 13
          }, ];
        }
        this.isIndeterminate = false;
        this.tableclumn = this.tableclumn1.concat(this.tableclumn2);
        // console.log('选择的字段', this.tableclumn)
      },
      //全员导出字段选择
      handleCheckedCitiesChange(value) {
        // console.log('val', value)
        this.tableclumn1 = [{
          colname: "StrIdCard",
          name: "身份证号码",
          intOrderId: 13
        }, ];
        for (let index = 0; index < this.currFileData.length; index++) {
          // const elementFileDatas = this.currFileData[index];
          if (value != "" && value != null) {
            for (let i = 0; i < value.length; i++) {
              if (value[i] == this.currFileData[index].name) {
                this.tableclumn1.push(this.currFileData[index]);
              }
            }
          } else {
            this.tableclumn1 = [{
              colname: "StrIdCard",
              name: "身份证号码",
              intOrderId: 13
            }, ];
          }
        }
        //去重
        this.tableclumn1 = this.unique(this.tableclumn1);
        this.tableclumn = this.tableclumn1.concat(this.tableclumn2);
        // console.log('val', this.tableclumn)
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.fixedfields.length;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.fixedfields.length;
      },
      //去重
      unique(arr) {
        const resList = new Map();
        return arr.filter(
          (arr) => !resList.has(arr.name) && resList.set(arr.name, 1)
        );
      },
      //获取所有字段信息
      getImportFiledList() {
        // const data = {
        //   pagecount: 100000,
        //   currpage: 1,
        //   tablename: "",
        //   coluname: "",
        //   strisfixed: "all", //strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
        // };
        this.fixedfields = [];
        xz.getJbbasePageColumnList('JB_emp_UserBase', '').then((res) => {
          // console.log('固定导出字段',res)
          if (res && res.msg.length > 0) {
            for (let index = 0; index < res.msg.length; index++) {
              const elementRes = res.msg[index];
              this.fixedfields.push({
                name: elementRes.StrColumName,
                colname: elementRes.StrColumId,
                intOrderId: elementRes.IntOrderId,
              });
              this.allFieldList.push({
                name: elementRes.StrColumName,
                colname: elementRes.StrColumId,
                intOrderId: elementRes.IntOrderId,
              });
            }
            //去重
            this.currFileData = this.unique(this.fixedfields);
            this.fixedfields = [];
            for (let index = 0; index < this.currFileData.length; index++) {
              const elementData = this.currFileData[index];
              this.fixedfields.push(elementData.name);
            }
            // console.log('s1', this.fixedfields, this.allFieldList)
          }
        });
      },
      //获取最新一条导出记录
      async getlastExportList() {
        xz.bgetlastimpdata("全员导出").then((res) => {
          // console.log('全员导出', res)
          if (res && res != "没有记录！") {
            if (
              new Date().getTime() < new Date(res.DtImpDate).getTime() + 360000 &&
              this.isNull(res.StrOutPath)
            ) {
              this.$message({
                showClose: true,
                message: "全员导出一次后需六分钟后才能再导出，请稍后再导",
                type: "warning",
              });
            } else {
              this.dialogVisible4 = true;
            }
          } else {
            this.dialogVisible4 = true;
          }
        });
      },
      confirmExport() {
        // this.dialogVisible4 = true;
        if (!this.checkAll) {
          this.tableclumn.sort(function (a, b) {
            return a.intOrderId - b.intOrderId;
          });
        }
        // console.log('this.tableclumn', this.tableclumn)
        const data = {
          custname: "全员导出",
          strworkstate: this.workState,
          outtype: "1",
          tableid: "JB_emp_UserBase",
          roletype: localStorage.loginRoletype,
          tableclumn: this.tableclumn,
        };
        // console.log('导出', data)
        let Promise = xz.bdowncurrdata(data);
        this.$router.push({
          path: "/resImportList",
          query: {
            showPage: 1,
            isActive: 1,
            custname: "全员导出",
            //qStstus=1时查看最后一条导出记录
            qStstus: 1,
          },
        });
      },
      //点击客户转跳到客户花名册
      handdle(row) {
        // console.log(row, event, column, cell)
        // this.$router.push({
        //   path: "/rosterDtl",
        //   query: {
        //     instname: row.StrObjInstName,
        //     servusrname: row.StrUserName,
        //     servcentname: row.StrSrvCent,
        //     custname: row.StrObjName,
        //     entid: row.GdObjId,
        //   }
        // });
        this.$router.push({
          path: "/empRosterPerson",
          query: {
            active:'花名册列表',
            objname: row.StrObjName
          }
        });
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      columnStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        // if (column.label == "项目名称") {
        return "cursor: pointer";
        // }
      },
      closeRead() {
        this.visibleReading = false;
        window.localStorage.setItem(
          "visibleReadingCustomer",
          this.monthFirstDates
        );
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-customer .el-button.is-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }

  .top-right {
    display: flex;
    align-items: center;
  }

  .top-right .el-button--text {
    padding: 7px 10px;
    border: solid 1px #19bd92;
    font-size: 12px;
    color: #19bd92;
    border-radius: 4px;
    background-color: #fff;
  }

  .top-right .el-button--text img {
    vertical-align: sub;
  }

  .form-item {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    margin-bottom: 20px;
  }

  .steps-box {
    margin-top: 20px;
  }

  .steps-box .el-step__title {
    font-size: 14px;
    color: #999;
  }

  .form-item label {
    width: 56px;
    text-align: right;
  }

  .form-item span {
    color: #ff3228;
  }

  .form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    margin-top: 10px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  /* 这是主要的，文件上传按钮的样式 */
  .file-box {
    position: relative;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 30px;
    background: #fff;
    border: 1px solid #ccc;
    text-align: center !important;
    line-height: 32px;
    color: #333333;
    margin-left: 8px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .employeeRosterTable {
    background-color: #fff;
  }
</style>

<style>
  .cus_down_form {
    margin-top: 8px;
  }

  .cus_down_form .el-form-item {
    margin-bottom: 3px;
  }

  .cus_down_form .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .cus_down_form .el-select,
  .cus_down_form .el-form-item__content {
    width: 220px;
  }

  .p_roster_table.el-tabs--card {
    background-color: #fff;
  }

  .screenInputs .screenInput .el-input {
    width: 155px;
    margin-left: 5px;
  }

  .screenInput .el-select .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .screenInput .el-input__icon {
    line-height: 32px;
  }

  .dialog .el-dialog__header {
    padding: 0;
  }

  .dialog .el-dialog__body {
    padding: 20px 20px 0 20px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .reimpArea .el-input__inner {
    height: 32px;
    line-height: 32px;
    margin-top: 10px;
  }

  .reimpArea .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .employeeRosterTable .el-table th>.cell {
    padding: 0;
  }

  .employeeRosterTable .el-table .cell {
    padding: 0;
  }

  .employeeRosterTable .el-table td {
    padding: 6px 0;
  }

  .employeeRosterTable .el-table th {
    padding: 6px 0;
  }

  .storageInput .el-input--small .el-input__inner {
    width: 368px;
    height: 32px;
  }

  .storageInput .el-input--small {
    width: 360px;
  }

  .storageArea .upload-demo {
    height: 32px;
  }

  .storageArea .el-button--primary {
    background-color: #fff;
    color: #000;
    border-color: #ccc;
  }

  .el-button--primary:focus,
  .el-button--primary:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }

  .storageArea .el-button {
    padding: 9px 15px;
  }

  .dialog .el-dialog__header {
    padding: 0;
  }

  .dialog .el-dialog__body {
    padding: 20px 20px 0 20px;
  }

  .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #19bd92 !important;
  }

  .el-popconfirm__action {
    margin-top: 15px;
  }
</style>